// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tit-section[data-v-c00c8c32]{\r\nbackground-image: linear-gradient(#ececec,#ececec);\r\ncolor: black;\n}\n.btn[data-v-c00c8c32]{\r\n    padding:10px !important\n}\n.btnclr[data-v-c00c8c32]{\r\n    width: 100%;\r\n    border:1px solid #e8e8e8;\r\n    height:48px !important\n}\n.btnClose[data-v-c00c8c32]{\r\n     width: 20%;\r\n     height:48px !important\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
